import script from "./IconTextButton.vue?vue&type=script&setup=true&lang=js"
export * from "./IconTextButton.vue?vue&type=script&setup=true&lang=js"

import "./IconTextButton.vue?vue&type=style&index=0&id=66111b52&lang=scss"

const __exports__ = script;

export default __exports__